module.exports = require('./generateRecipesIndex')
